import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children, allowedRoles }) {
  const { authenticated, user, loading, logout, initialize } = useAuthContext();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const response = await initialize();

        if (!response.authenticated) { await logout(); }

        setInitialized(true);
      } catch (error) {
        //console.error('Error during auth initialization:', error);
        setInitialized(true); // Même en cas d'échec, on doit rendre une vue (par exemple une redirection).
      }
    };

    initializeAuth();
  }, [initialize, logout]);

  if (!initialized || loading) {
    return <LoadingScreen />; // Affiche un écran de chargement tant que l'initialisation est en cours
  }

  if (!authenticated || !allowedRoles.includes(user?.role)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}


AuthGuard.propTypes = {
  children: PropTypes.node,
  allowedRoles: PropTypes.arrayOf(PropTypes.string), // Exemple : ['admin', 'editor']
};


